import React from 'react';
import styled from 'styled-components';
import {
  StyledCard,
  CardHeader,
  CardBody,
} from '../../styles/CardTextAndContainers';
import FeedbackForm from '../forms/FeedbackForm';

const FeedbackCard = () => {
  return (
    <StyledCard>
      <CardHeader>Thank you! Anything we can help you with?</CardHeader>
      <CardBody>
        Business Sweden has helped hundreds of Swedish companies find suitable
        business partners. Our global network of offices remain ready to support
        you in growing your global sales.
      </CardBody>
      <FlexContainer>
        <FeedbackForm />
      </FlexContainer>
    </StyledCard>
  );
};

const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default FeedbackCard;
